import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "src/hooks/useRequest";

export const useOrderCountByPaymentStatus = ( query: Record<string, QueryParamsType>) => {
  const url = `/dashboard/order-count-by-payment-status?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    data: data as any,
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
